import React, { useEffect } from "react";
import { Helmet } from "react-helmet";

import NavBar from "../components/common/navBar";
import Footer from "../components/common/footer";
import Logo from "../components/common/logo";
import Socials from "../components/about/socials";

import INFO from "../data/user";
import SEO from "../data/seo";

import "./styles/about.css";

const About = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const currentSEO = SEO.find((item) => item.page === "about");

  return (
    <React.Fragment>
      <Helmet>
        <title>{`About | ${INFO.main.title}`}</title>
        <meta name="description" content={currentSEO.description} />
        <meta name="keywords" content={currentSEO.keywords.join(", ")} />
      </Helmet>

      <div className="page-content">
        <NavBar active="about" />
        <div className="content-wrapper">
          <div className="about-logo-container">
            <div className="about-logo">
              <Logo width={46} />
            </div>
          </div>

          <div className="about-container">
            <div className="about-main">
              <div className="about-right-side">
                <div className="title about-title">{INFO.about.title}</div>

                <div className="subtitle about-subtitle">{INFO.about.description}</div>

                {/* Skills Section */}
                <div className="about-skills">
                  <div className="skills-title">{INFO.skills.title}</div>
                  <ul className="skills-list">
                    {INFO.skills.description.map((skill, index) => (
                      <li key={index}>{skill}</li>
                    ))}
                  </ul>
                </div>

                {/* Resume Section */}
                <div className="resume-section">
                  <h3>Resume</h3>

                  {/* Education */}
                  <h4>Education</h4>
                  {INFO.resume.education.map((edu, index) => (
                    <div key={index}>
                      <h5>{edu.school}</h5>
                      <p>{edu.degree} - {edu.duration}</p>
                      <p>{edu.location}</p>
                    </div>
                  ))}

                  {/* Training */}
                  <h4>Trainings</h4>
                  {INFO.resume.training.map((training, index) => (
                    <div key={index}>
                      <h5>{training.title}</h5>
                      <p>{training.organization} - {training.duration}</p>
                      <p>{training.description}</p>
                    </div>
                  ))}

                  {/* Experience */}
                  <h4>Experience</h4>
                  <h5>{INFO.resume.experience.title}</h5>
                  <p>{INFO.resume.experience.organization} - {INFO.resume.experience.duration}</p>
                  <ul>
                    {INFO.resume.experience.achievements.map((achievement, index) => (
                      <li key={index}>{achievement}</li>
                    ))}
                  </ul>

                  {/* Resume Download Button */}
                  <a href={`/${INFO.resume.file}`} download>
                    <button className="resume-download-button">Download Resume</button>
                  </a>
                </div>
              </div>

              <div className="about-left-side">
                <div className="about-image-container">
                  <div className="about-image-wrapper">
                    <img src="about.jpg" alt="about" className="about-image" />
                  </div>
                </div>

                <div className="about-socials">
                  <Socials />
                </div>
              </div>
            </div>
            <div className="about-socials-mobile">
              <Socials />
            </div>
          </div>
          <div className="page-footer">
            <Footer />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default About;
